module.exports = __webpack_public_path__ + "static/img/bg3.e8e43a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/bg3.jpg
// module id = Ml6C
// module chunks = 69